import * as _ from 'lodash';

import { Funding } from '@finley-technologies/finley-types';

import {
  getFixedFormValuesByPricingOption,
  getBenchmarkFormValuesByPricingOption,
} from '~/core/routes/settings/implementations/[implementationId]/facilities/[facilityId]/pricing-options/[pricingOptionId]/dataMappings/getFormValues';
import { useCreditAgreementStore } from '~/core/routes/settings/implementations/common/CreditAgreementProvider/CreditAgreementProvider';
import { computeDiff } from '~/core/routes/settings/implementations/common/DiffInputs/hooks';

const getFormData = (
  pricingOption: Funding.LoanMechanics['pricingOptions'][number] | undefined,
) => {
  if (pricingOption === undefined) return undefined;
  if (pricingOption.type === 'fixed')
    return getFixedFormValuesByPricingOption(pricingOption);
  if (pricingOption.type === 'benchmark')
    return getBenchmarkFormValuesByPricingOption(pricingOption);
  return undefined;
};

export const usePricingOptionDiffResult = (pricingOptionKey: string) => {
  return useCreditAgreementStore((store) => {
    const currentCreditAgreement = store.creditAgreement;
    const previousCreditAgreement = store.previousCreditAgreement;

    if (currentCreditAgreement && previousCreditAgreement) {
      const currentPricingOption = currentCreditAgreement.loanMechanicsV1?.pricingOptions.find(
        (pricingOption) => pricingOption.key === pricingOptionKey,
      );

      const previousPricingOption = previousCreditAgreement.loanMechanicsV1?.pricingOptions.find(
        (pricingOption) => pricingOption.key === pricingOptionKey,
      );

      const previousPricingOptionFormData = getFormData(previousPricingOption);
      const currentPricingOptionFormData = getFormData(currentPricingOption);

      const diffResult = computeDiff(
        currentPricingOptionFormData,
        previousPricingOptionFormData,
        _.isEqual,
      );

      return {
        currentPricingOptionFormData,
        previousPricingOptionFormData,
        diffResult,
      };
    }

    return undefined;
  }, _.isEqual);
};
